module.exports = __webpack_public_path__ + "img/search-oliver.5eb5cf57.png";